export class TypeformTheme {
    constructor(
        public id: string,
        public name: string,
        public font: string,
        public has_transparent_button: string,
        public colors: TypeformThemeColors,
        public background: TypeformThemeBackground|null,
        public logo: TypeformThemeLogo|null,
        public screens: TypeformThemeScreens,
        public fields: TypeformThemeFields,
        public created_at: Date,
        public updated_at: Date,
    ) {}

    toRequestData(): any {
        const requestData: any = {
            name: this.name,
            font: this.font,
            has_transparent_button: this.has_transparent_button,
            colors: this.colors,
            screens: this.screens,
            fields: this.fields,
        }

        if (this.background) {
            requestData.background = this.background
        }

        if (this.logo) {
            requestData.logo = this.logo
        }

        return requestData
    }

    static fromData(data: any): TypeformTheme {
        if (data === null || typeof data === 'string' || data instanceof TypeformTheme) {
            return data
        }

        return new TypeformTheme(
            data.id,
            data.name,
            data.font,
            data.has_transparent_button,
            data.colors,
            data.background || null,
            data.logo || null,
            data.screens,
            data.fields,
            data.created_at,
            data.updated_at,
        )
    }
}

export interface TypeformThemeColors {
    question: string,
    answer: string,
    button: string,
    button_content: string,
    background: string,
}

export interface TypeformThemeBackground {
    href: string,
    layout: string,
    brightness: number,
}

export interface TypeformThemeLogo {
    href: string,
}

export interface TypeformThemeScreens {
    font_size: string,
    alignment: string,
}
export interface TypeformThemeFields {
    font_size: string,
    alignment: string,
}
